import { Params, PRIMARY_OUTLET, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { ModelTransformer } from '../common/common.model';

export const NAV_HEIGHT = 72; // TODO revise. navbar height. see _variables

export interface NavLoader {
    loadPhoto: () => Observable<string>;

    load: (forceReload: boolean) => Observable<NavItem[]>;
}

export interface ExtMenuItem {
    displayOrder: number;
    defaultName: string;
    link: string;
    openInNewTab: boolean;
    children?: ExtMenuItem[];
}

export interface NavItem {
    defaultName: string;
    link: string | string[];
    queryParams: Params;
    openInNewTab: boolean;
    children?: NavItem[];
    hasChildren: boolean;
    isNested: boolean;
    isExternal: boolean;
}

export class NavModelTransformer
    implements ModelTransformer<NavItem[], ExtMenuItem[]>
{
    constructor(private readonly _router: Router) {}

    transform(model: ExtMenuItem[]): NavItem[] {
        return this._transformChildren(model);
    }

    private _transformChildren(items: ExtMenuItem[]): NavItem[] {
        const transformed: NavItem[] = [];
        (items || [])
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .forEach((item) => {
                const children: NavItem[] = this._transformChildren(
                    item.children,
                );
                const hasChildren: boolean = !!children && !!children.length;
                const isNested: boolean =
                    hasChildren &&
                    !!children.find(
                        (item) => item.children && !!item.children.length,
                    );
                const hasLink: boolean = !!item.link && !!item.link.length;
                if (!hasLink && !hasChildren) return;
                const isExternalItem: boolean =
                    hasLink && item.link.startsWith('^');
                let link = null;
                let queryParams = null;
                if (isExternalItem) {
                    link = item.link.substring(1);
                } else {
                    // TODO revise
                    const tree = this._router.parseUrl(
                        (item.link || '').toLowerCase(),
                    );
                    // eslint-disable-next-line no-prototype-builtins
                    if (tree.root.children.hasOwnProperty(PRIMARY_OUTLET)) {
                        const g = tree.root.children[PRIMARY_OUTLET];
                        link = g.segments.map((s) => s.path).filter((p) => !!p);
                        queryParams = { ...tree.queryParams };
                    }
                }
                transformed.push({
                    defaultName: item.defaultName,
                    link,
                    queryParams,
                    openInNewTab: item.openInNewTab,
                    children,
                    hasChildren,
                    isNested,
                    isExternal: isExternalItem,
                });
            });
        return transformed;
    }
}
